import { createUseStyles } from 'react-jss'
import { colors } from '../../../variables.style'

export const style = {
  toolbar: {
    composes: 'flex-row',
    height: 32,
    backgroundColor: colors.metallicSeaweed
  },
  columnButton: {
    composes: 'flex-row',
    color: 'white',
    fontSize: 18,
    width: 42,
    height: 31,
    margin: '0 1px 1px 1px',
    padding: '5px 5px 5px 7px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'white',
      color: colors.metallicSeaweed
    }
  },
  columnIcon: {
    composes: 'font-icon-table-column',
    fontSize: 18
  },
  rowButton: {
    extend: 'columnButton',
    margin: '0 1px 1px 0',
    padding: '5px 5px 5px 6px'
  },
  rowIcon: {
    extend: 'columnIcon',
    transform: 'rotate(90deg)'
  },
  downCaret: {
    composes: 'font-icon-down-caret flex-row flex-center-items',
    fontSize: 8,
    marginLeft: 4
  },
  disable: {
    pointerEvents: 'none',
    opacity: '0.5'
  }
}

export const useStyles = createUseStyles(style)
